import { createContext, useState, useCallback } from "react";
import { State } from "../data/constants";

export const SaveStateContext = createContext(State.NONE);

export default function SaveStateContextProvider({ children }) {
  const [saveState, setSaveState] = useState(State.NONE);

  const wrappedSetSaveState = useCallback((newSaveState) => {
    setSaveState(newSaveState);
  }, []);

  return (
    <SaveStateContext.Provider value={{ saveState, setSaveState: wrappedSetSaveState }}>
      {children}
    </SaveStateContext.Provider>
  );
}
